import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import Scroll from '@/popup/components/shared/Scroll/Scroll.vue'

type Props = {
  extraClass?: string
  scrollable?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Content',
  props: {
    extraClass: {},
    scrollable: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.scrollable)
    ? (_openBlock(), _createBlock(Scroll, {
        key: 0,
        class: _normalizeClass(["modal-content", _ctx.extraClass])
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["class"]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["modal-content", _ctx.extraClass])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2 /* CLASS */))
}
}

})